module.exports = "/img/vdf_bg.jpg?a4911b30aa73dad3f5f5289b16e078f0";